var _path, _circle, _path2, _circle2, _path3, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconFilter = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#51504F",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 2,
    d: "M12 3L12 11M12 16L12 19"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 14,
    r: 2,
    stroke: "#51504F",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#51504F",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 2,
    d: "M19 3L19 6M19 11L19 19"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 8,
    r: 2,
    stroke: "#51504F",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#51504F",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 2,
    d: "M5 12L5 19M5 3L5 7"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 10,
    r: 2,
    stroke: "#51504F",
    strokeWidth: 2
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconFilter, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_filter.9f75c590.svg";
export { ForwardRef as ReactComponent };